import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import type { Subscription } from 'rxjs';
import { Subject, timer } from 'rxjs';
import { take } from 'rxjs/operators';

import type { IWaitFor } from 'src/services/personal-data-protection/types';

@Injectable()
export class WaitForGaCookieService implements IWaitFor {
    private cookieService = inject(CookieService);

    private readonly period = 500;
    private readonly timeout = 20000;
    private readonly defaultGaCookieOptions = {
        name: '_ga',
    };

    private readonly subject = new Subject<void>();
    private timerSubscription: Subscription;

    public wait() {
        if (this.timerSubscription) {
            return this.subject.toPromise();
        } else {
            this.timerSubscription = timer(0, this.period)
                .pipe(take(this.timeout / this.period))
                .subscribe(
                    () => {
                        if (this.cookieService.get(this.defaultGaCookieOptions.name)) {
                            this.subject.complete();
                            this.timerSubscription.unsubscribe();
                        }
                    },
                    (error) => console.error(error)
                );

            return this.subject.toPromise();
        }
    }
}
